module.exports = __webpack_public_path__ + "img/0155353a571546788808eefbb563163a-640.b1ebb648.jpg";